import ConditionalChildrenExample from "./examples/ConditionalChildren.Example";

export default [
    {
        title: "Conditional Children example",
        component: ConditionalChildrenExample,
        code: require("!raw-loader!./examples/ConditionalChildren.Example.tsx")
    }
];
